export const initialState: ISpecialPrices = {
  isSpecialsLoaded: false,
  discounts: [],
  individualPrices: [],
  productListWithPrices: {},
  offerPrices: [],
}

export interface ISpecialPrices {
  isSpecialsLoaded: boolean
  discounts: IDiscount[]
  individualPrices: IIndivPrice[]
  productListWithPrices: IPriceList
  offerPrices: IOfferPrice[]
}

export interface IDiscount {
  discountPercentage: number
  productId: number
  description: string
}

export interface IIndivPrice {
  description: string
  price: number
  price2: number
  productId: number
}

// CashAssistPrices Type 3 (Angebotspreis) — the backend resolves the level cascade
// and 5-cent rounding, the client receives one final price per article.
export interface IOfferPrice {
  productId: number
  description: string
  validTo?: string | null
  price: number
}

export interface IPriceList {
  [key: string]: IPriceListItem
}
export interface IPriceListItem {
  price2E2: number
  priceE2: number
  productNr: string
  templateId: number
  title: string
  type: string
  withDiscount: boolean
  withSurcharge: boolean
  menuItems?: IPriceListMenuItem[]
}

export interface IPriceListMenuItem {
  categoryId: number
  categoryName: string
  fixedNums: string[]
  fixedItems: FixedItemType[]
  items: {
    price: number
    productId: number
    productNr: string
    title: string
    fixedPrice?: number
  }[]
  priceLevel: number
  withFixed: boolean
  minCount: number
  maxCount: number
}

export type FixedItemType = {
  count: number
  fixedPrice: number
  id: number
  productNr: string
}

export interface IFetchSpecialsParams {
  guid: string
  registerId: string | number
}
